export const chessGridVertexShader = `#version 300 es

in vec2 a_position;
in vec2 a_texCoord;

uniform mat3 u_camViewProjection;
uniform mat3 u_model;

out vec2 v_texCoord;

void main() {
    mat3 u_matrix = u_camViewProjection * u_model;
    vec3 position = u_matrix * vec3(a_position, 1);
    gl_Position = vec4(position, 1);
    
    v_texCoord = a_texCoord;
}
`;

export const chessGridFragmentShader = `#version 300 es

precision highp float;

in vec2 v_texCoord;

uniform float u_camScale;
uniform vec2 u_size;
uniform float u_gridSize;
uniform vec4 u_color;

out vec4 outColor;

void main() {
  vec2 uv_local_scaled = v_texCoord * (u_camScale / u_gridSize);
  vec2 pixel_local = floor(uv_local_scaled * u_size);
  vec2 pixel_modulo_local = mod(pixel_local, 2.0);

  float t = mod(pixel_modulo_local.x + pixel_modulo_local.y, 2.0);

  vec3 white = vec3(1.0, 1.0, 1.0);
  vec3 grey = vec3(0.78, 0.78, 0.78);
  vec3 color = mix(white, grey, t);
  vec4 finalColor = (u_color.a == 0.0) ? vec4(color, 1.0) : u_color;

  outColor = finalColor;
}
`;
